import { Badge } from "@oysterhr/ui"
import { PaymentStatusLabelsMap } from "../../constants/paymentStatus"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import { BadDebtCategory } from "@oysterhr/schema"

interface Props {
  state?: BadDebtCategory | null
  onClick?: () => void
}

export const CompanyPaymentStatusBadge = ({ state, onClick }: Props) => {
  const { t } = useTranslation("invoices/CompanyPaymentStatusSection", {
    keyPrefix: "customerPaymentStatus",
  })
  if (!state) return null
  const { variation, translationKey } = PaymentStatusLabelsMap[state]

  return (
    <Badge
      variation={variation}
      isOutline
      onClick={onClick}
      className={classNames({ "cursor-pointer": !!onClick })}
    >
      {t(translationKey)}
    </Badge>
  )
}
